module.exports = __webpack_public_path__ + "media/images/subarena_v4-2daf11b7f297fd47191205acb902c85d.png";